import { useNavigate, useParams } from "react-router-dom"
import EditMapScreen from "../_form/edit"

export default function EditLayoutMapsPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const onSuccess = () => {
    navigate("/config/layout-maps?mock=data", {
      replace: true
    })
  }

  const onCancel = () => {
    navigate(-1)
  }
  
  return (
    <>
      {id && (
        <EditMapScreen
          uuid={id}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      )}
    </>
  )
}